import { render, staticRenderFns } from "./Work_from_lab.vue?vue&type=template&id=8ed9295a&"
import script from "./Work_from_lab.vue?vue&type=script&lang=js&"
export * from "./Work_from_lab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports